import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card, Field } from "@/components/admin/challenge/ChallengeAdminParts";

const ROWS = [
  ["teilnehmer", "Challenge-Teilnehmer"],
  ...[1, 2, 3, 4, 5].flatMap((d) => [[`tag${d}_geoeffnet`, `Tag ${d} geöffnet`], [`tag${d}_beendet`, `Tag ${d} beendet`]]),
  ["challenge_abgeschlossen", "Challenge abgeschlossen (Tag 5 beendet)"],
  ["wrapup_geoeffnet", "Wrap-up geöffnet"],
  ["checkout_geoeffnet", "Checkout geöffnet"],
  ["pro_testnutzer", "Pro-Testnutzer (1 € abgeschlossen)"],
  ["test_gekuendigt", "Im Test gekündigt"],
  ["paid_customer", "Paid Customer (39 € ab Tag 8)"],
];
const GROUPS = [["alle", "Alle"], ["katze", "Katze"], ["eule", "Eule"], ["hund", "Hund"], ["biene", "Biene"], ["keiner", "ohne Typ"]];

export const ChallengeFunnel = ({ funnel }) => {
  const by = funnel.nach_fokustyp || {};
  return (
    <Card title="Fortschritt und Übergänge nach Fokustyp (nur Echtdaten)" testId="ch2-funnel">
      <p className="text-xs text-slate-500">Link geöffnet (eindeutige Adressen): <b data-testid="ch2-funnel-link_geoeffnet">{funnel.link_geoeffnet ?? 0}</b></p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="py-1.5 text-left text-xs text-slate-500">Schritt</th>
              {GROUPS.map(([g, l]) => <th key={g} className="py-1.5 px-1 text-right text-xs text-slate-500">{l}</th>)}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([k, l]) => (
              <tr key={k} className="border-b border-slate-100 last:border-0">
                <td className="py-1.5 text-slate-600">{l}</td>
                {GROUPS.map(([g]) => (
                  <td key={g} className={`py-1.5 px-1 text-right tabular-nums ${g === "alle" ? "font-bold" : ""}`} data-testid={`ch2-funnel-${k}-${g}`}>{by[g]?.[k] ?? 0}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500" data-testid="ch2-funnel-test-excluded">{funnel.test_excluded ?? 0} Testkonten herausgefiltert · Fokustyp laut Konto</p>
    </Card>
  );
};

export const ChallengeTestTools = () => {
  const [email, setEmail] = useState("andreas+test-challenge@laimisch.de");
  const [hours, setHours] = useState("24");
  const [out, setOut] = useState(null);
  const run = async (fn) => {
    try { setOut(await fn()); } catch (e) { setOut({ error: e?.response?.data?.detail || "Fehler" }); }
  };
  return (
    <Card title="Test-Werkzeuge (nur Testkonten)" testId="ch2-test-tools">
      <Field label="Testadresse" value={email} onChange={setEmail} testId="ch2-test-email" />
      <div className="flex flex-wrap gap-2 items-end">
        <button type="button" data-testid="ch2-test-link-btn" className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
          onClick={() => run(async () => { const { data } = await api.post("/admin/challenge2/test-link", { email, fn: "Test" }); return { link: window.location.origin + data.join_path }; })}>
          Testlink erzeugen
        </button>
        <div className="w-28"><Field label="Stunden vorspulen" value={hours} onChange={setHours} testId="ch2-test-hours" /></div>
        <button type="button" data-testid="ch2-test-shift-btn" className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
          onClick={() => run(async () => (await api.post("/admin/challenge2/test-shift", { email, hours: Number(hours) })).data)}>
          Testuhr vorspulen
        </button>
        <button type="button" data-testid="ch2-test-reminder-btn" className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
          onClick={() => run(async () => (await api.post("/admin/challenge2/reminders/run", { email })).data)}>
          Fällige Erinnerung jetzt senden
        </button>
      </div>
      {out && <pre className="text-xs bg-slate-50 border border-slate-200 rounded-lg p-3 whitespace-pre-wrap break-all" data-testid="ch2-test-output">{JSON.stringify(out, null, 2)}</pre>}
    </Card>
  );
};
